module.exports = "/_next/static/images/DeepenUnderstanding-4d9ca3ce867ef8d0d048eba57f61357e.webp";